import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../css/UnitList.css";

const DepartmentDiscountList = () => {
  const navigate = useNavigate();
  const [discounts, setDiscounts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [toast, setToast] = useState({ show: false, message: "", type: "" });
  const [deleteModal, setDeleteModal] = useState({ show: false, discount: null });
  const API_URL = process.env.REACT_APP_API_URL || "";

  useEffect(() => {
    const apiUrl = `${API_URL}list-dept-discount.php`;
    fetch(apiUrl)
      .then((res) => res.json())
      .then((response) => {
        if (response.status === "success" && Array.isArray(response.data)) {
          setDiscounts(response.data);
        } else {
          showToast("Failed to load department discounts", "error");
        }
      })
      .catch(() => showToast("Error fetching data from the server", "error"));
  }, [API_URL]);

  const showToast = (message, type = "success") => {
    setToast({ show: true, message, type });
    setTimeout(() => {
      setToast({ show: false, message: "", type: "" });
    }, 3000);
  };

  const filteredDiscounts = discounts.filter((item) => {
    const term = searchTerm.toLowerCase();
    return item.dept_name && item.dept_name.toLowerCase().includes(term);
  });

  const handleEdit = (item) => {
    navigate("/add-department-discount", { state: { discount: item, isEditing: true } });
    showToast(`Editing discount for: ${item.dept_name}`, "info");
  };

  const handleDelete = (item) => {
    setDeleteModal({ show: true, discount: item });
  };

  const confirmDelete = async () => {
    const { discount } = deleteModal;
    try {
      const response = await fetch(`${API_URL}delete-dept-discount.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: discount.id }),
      });

      const data = await response.json();

      if (data.message && data.message.includes("deleted successfully")) {
        showToast(
          `Discount for "${discount.dept_name}" deleted successfully`,
          "success"
        );
        setDiscounts((prevDiscounts) =>
          prevDiscounts.filter((item) => item.id !== discount.id)
        );
      } else if (data.status === "success") {
        // Fallback for APIs that use status field
        showToast(
          `Discount for "${discount.dept_name}" deleted successfully`,
          "success"
        );
        setDiscounts((prevDiscounts) =>
          prevDiscounts.filter((item) => item.id !== discount.id)
        );
      } else {
        showToast(data.message || "Failed to delete discount", "error");
      }
    } catch (error) {
      showToast("Network error. Could not delete discount.", "error");
    }
    setDeleteModal({ show: false, discount: null });
  };

  const cancelDelete = () => {
    setDeleteModal({ show: false, discount: null });
  };

  const handleAddDiscount = () => {
    navigate("/add-department-discount");
  };

  return (
    <div className="category-list-content">
      <div className="page-header">
        <div className="header-content">
          <h1>Department Discounts</h1>
          <p>Manage special discounts assigned to departments</p>
        </div>
        <button className="add-unit-button" onClick={handleAddDiscount}>
          + Add New Discount
        </button>
      </div>

      <div className="filters-section">
        <div className="search-box">
          <input
            type="text"
            placeholder="Search by department name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      <div className="unit-list-table-container">
        <table className="unit-list-table">
          <thead>
            <tr>
              <th>Department Name</th>
              <th>Discount (%)</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredDiscounts.map((item) => (
              <tr key={item.id}>
                <td>
                  <div className="unit-info">
                    <div className="unit-icon">🏢</div>
                    <span>{item.dept_name}</span>
                  </div>
                </td>
                <td>{parseFloat(item.discount).toFixed(2)}%</td>
                <td>
                  <div className="action-buttons">
                    <button
                      className="action-btn edit"
                      onClick={() => handleEdit(item)}
                    >
                      Edit
                    </button>
                    <button
                      className="action-btn delete"
                      onClick={() => handleDelete(item)}
                    >
                      Delete
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="table-footer">
        <div className="results-info">
          Showing {filteredDiscounts.length} of {discounts.length} records
        </div>
      </div>

      {toast.show && (
        <div className={`toast toast-${toast.type}`}>
          <div className="toast-content">
            <span className="toast-message">{toast.message}</span>
            <button
              className="toast-close"
              onClick={() => setToast({ show: false, message: "", type: "" })}
            >
              ×
            </button>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {deleteModal.show && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h3>Confirm Delete</h3>
            </div>
            <div className="modal-body">
              <p>
                Are you sure you want to delete the discount for{" "}
                <strong>"{deleteModal.discount?.dept_name}"</strong>?
              </p>
              <p>This action cannot be undone.</p>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={cancelDelete}>
                No, Cancel
              </button>
              <button className="btn btn-danger" onClick={confirmDelete}>
                Yes, Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DepartmentDiscountList;
